import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import Button from 'src/components/Button';
import { deleteUserFromOrganizationAPI } from 'src/serverApi/organizationUsers';
import useWithAuthorities from 'src/utils/useWithAuthorities';
import permissions from 'src/constants/permissions';
import Modal from 'src/components/Modal';
import Text from 'src/components/Text';
import { OrganizationsContext } from '../OrganizationContextProvider';
import styles from './styles.module.scss';

type Props = {
  organizationUser: {
    id: string;
    firstName: string;
    secondName: string;
  };
  handleUsersChange: () => void;
};

const DeleteUserLink: React.FC<Props> = ({ organizationUser , handleUsersChange}) => {
  const { currentOrganization } = useContext(OrganizationsContext);
  const withDataManagementAuthorities = useWithAuthorities([permissions.dataManagement]);
  const [isDialogOpen, setDialogOpen] = useState(false);
  
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  
  const handleDeleteUser = (e: any) => {
    e.preventDefault();
    setDialogOpen(true);
  };
  
  const handleDeleteUserAccept = async (e: any) => {
    e.preventDefault();
  
    try {
      withDataManagementAuthorities(async () => {
        await deleteUserFromOrganizationAPI(
          currentOrganization?.organizationUeid,
          organizationUser.id
        );
        handleUsersChange();
        toast.success('Пользователь удален из организации');
      });
    } catch (error) {
      toast.error('Произошла ошибка при удалении пользователя из организации');
    } finally {
      setDialogOpen(false);
    }
  };
  
  if (!currentOrganization) {
    return null;
  }
  
  return (
    <>
      <a href="#" onClick={handleDeleteUser}>
        Удалить
      </a>
      <Modal
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        title="Удаление пользователя"
        content={
          <Text type="p" muted>
            Вы действительно хотите удалить пользователя "{organizationUser.firstName} {organizationUser.secondName}"{' '}
            из организации "{currentOrganization?.name}"?
          </Text>
        }
        footer={
          <>
            <Button onClick={handleCloseDialog} className={styles['modal-button']}>
              Отмена
            </Button>
            <Button variant="outlined" onClick={handleDeleteUserAccept} className={styles['modal-button']}>
              Удалить
            </Button>
          </>
        }
      />
    </>
  );
};

export default DeleteUserLink;
